var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import { clearAllValuesFromStorages, getB2CaccessToken, getB2CrefreshToken, getInternalAccessToken, getInternalRefreshToken, setB2CaccessToken, setInternalAccessToken, setInternalRefreshToken, } from "./TokenHelper";
import { LOGOUT_ADMIN_REDIRECT_URL, LEGACY_LOGOUT_REDIRECT_URL, } from "../Utils/RedirectURIs";
var StatusCode;
(function (StatusCode) {
    StatusCode["SUCCESS"] = "10000";
    StatusCode["FAILURE"] = "10001";
    StatusCode["RETRY"] = "10002";
    StatusCode["INTERNAL_ACCESS_TOKEN_EXPIRED"] = "10003";
    StatusCode["B2C_ACCESS_TOKEN_EXPIRED"] = "10004";
    StatusCode["INVALID_B2C_REFRESH_TOKEN"] = "10005";
    StatusCode["INVALID_INTERNAL_REFRESH_TOKEN"] = "10006";
})(StatusCode || (StatusCode = {}));
var MethodTypes;
(function (MethodTypes) {
    MethodTypes[MethodTypes["GET"] = 0] = "GET";
    MethodTypes[MethodTypes["POST"] = 1] = "POST";
})(MethodTypes || (MethodTypes = {}));
var API_REFRESH_B2C_TOKEN_URL = process.env.REACT_APP_API_URL +
    "/api/unprotected/B2CAuthentication/RefreshToken";
var API_REFRESH_INTERNAL_TOKEN_URL = process.env.REACT_APP_API_URL + "/api/v1/User/RefreshToken";
export var postToServerAPIWithProvidedBearerToken = function (url, redirectBaseUrl, body, params, logoutUrl, isAdmin) {
    if (body === void 0) { body = {}; }
    if (params === void 0) { params = {}; }
    return __awaiter(void 0, void 0, Promise, function () {
        var b2cAccessToken, internalToken, bearerToken, response, e_1, response, response, e_2;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 10, , 11]);
                    b2cAccessToken = (_a = getB2CaccessToken()) !== null && _a !== void 0 ? _a : "";
                    internalToken = (_b = getInternalAccessToken()) !== null && _b !== void 0 ? _b : "";
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, , 9]);
                    bearerToken = "Bearer ".concat(b2cAccessToken);
                    return [4 /*yield*/, axios.post(url, body, {
                            headers: {
                                Authorization: bearerToken,
                                "Content-Type": "application/json; charset=utf-8",
                                InternalAuthorization: "Bearer ".concat(internalToken),
                            },
                            method: "POST",
                            params: params,
                        })];
                case 2:
                    response = _g.sent();
                    if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        handleErrorsExceptRefresh(response, redirectBaseUrl);
                        throw new Error();
                    }
                    return [3 /*break*/, 9];
                case 3:
                    e_1 = _g.sent();
                    if (!(((_c = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _c === void 0 ? void 0 : _c.status) === 401 &&
                        ((_d = e_1.response) === null || _d === void 0 ? void 0 : _d.data) &&
                        e_1.response.data.statusCode ===
                            StatusCode.B2C_ACCESS_TOKEN_EXPIRED)) return [3 /*break*/, 5];
                    return [4 /*yield*/, refreshB2CToken(url, redirectBaseUrl, internalToken, params, MethodTypes.POST, undefined, logoutUrl, isAdmin)];
                case 4:
                    response = _g.sent();
                    return [2 /*return*/, response];
                case 5:
                    if (!(((_e = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _e === void 0 ? void 0 : _e.status) === 401 &&
                        ((_f = e_1.response) === null || _f === void 0 ? void 0 : _f.data) &&
                        e_1.response.data.statusCode ===
                            StatusCode.INTERNAL_ACCESS_TOKEN_EXPIRED)) return [3 /*break*/, 7];
                    return [4 /*yield*/, refreshInternalToken(url, redirectBaseUrl, b2cAccessToken, internalToken, params, MethodTypes.POST, undefined, logoutUrl, isAdmin)];
                case 6:
                    response = _g.sent();
                    return [2 /*return*/, response];
                case 7:
                    handleErrorsExceptRefresh(e_1.response, redirectBaseUrl);
                    _g.label = 8;
                case 8: throw e_1;
                case 9: return [3 /*break*/, 11];
                case 10:
                    e_2 = _g.sent();
                    throw e_2;
                case 11: return [2 /*return*/];
            }
        });
    });
};
export var getFromServerAPIWithProvidedBearerToken = function (url, redirectBaseUrl, params, logoutUrl, isAdmin) {
    if (params === void 0) { params = {}; }
    return __awaiter(void 0, void 0, Promise, function () {
        var b2cAccessToken, internalToken, customConfig, bearerToken, response, e_3, customConfig, response, customConfig, response, e_4;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 10, , 11]);
                    b2cAccessToken = (_a = getB2CaccessToken()) !== null && _a !== void 0 ? _a : "";
                    internalToken = (_b = getInternalAccessToken()) !== null && _b !== void 0 ? _b : "";
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, , 9]);
                    customConfig = {
                        params: {},
                        headers: {},
                    };
                    if (params != null)
                        customConfig.params = params;
                    bearerToken = "Bearer ".concat(b2cAccessToken);
                    return [4 /*yield*/, axios.get(url, {
                            headers: {
                                Authorization: bearerToken,
                                "Content-Type": "application/json; charset=utf-8",
                                InternalAuthorization: "Bearer ".concat(internalToken),
                            },
                            method: "GET",
                            params: customConfig.params,
                        })];
                case 2:
                    response = _g.sent();
                    if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        handleErrorsExceptRefresh(response, redirectBaseUrl);
                        throw new Error();
                    }
                    return [3 /*break*/, 9];
                case 3:
                    e_3 = _g.sent();
                    if (!(((_c = e_3 === null || e_3 === void 0 ? void 0 : e_3.response) === null || _c === void 0 ? void 0 : _c.status) === 401 &&
                        ((_d = e_3.response) === null || _d === void 0 ? void 0 : _d.data) &&
                        e_3.response.data.statusCode ===
                            StatusCode.B2C_ACCESS_TOKEN_EXPIRED)) return [3 /*break*/, 5];
                    customConfig = {
                        params: {},
                        headers: {},
                    };
                    if (params != null)
                        customConfig.params = params;
                    return [4 /*yield*/, refreshB2CToken(url, redirectBaseUrl, internalToken, customConfig.params, MethodTypes.GET, undefined, logoutUrl, isAdmin)];
                case 4:
                    response = _g.sent();
                    return [2 /*return*/, response];
                case 5:
                    if (!(((_e = e_3 === null || e_3 === void 0 ? void 0 : e_3.response) === null || _e === void 0 ? void 0 : _e.status) === 401 &&
                        ((_f = e_3.response) === null || _f === void 0 ? void 0 : _f.data) &&
                        e_3.response.data.statusCode ===
                            StatusCode.INTERNAL_ACCESS_TOKEN_EXPIRED)) return [3 /*break*/, 7];
                    customConfig = {
                        params: {},
                        headers: {},
                    };
                    if (params != null)
                        customConfig.params = params;
                    return [4 /*yield*/, refreshInternalToken(url, redirectBaseUrl, b2cAccessToken, internalToken, params, MethodTypes.GET, undefined, logoutUrl, isAdmin)];
                case 6:
                    response = _g.sent();
                    return [2 /*return*/, response];
                case 7:
                    handleErrorsExceptRefresh(e_3.response, redirectBaseUrl);
                    _g.label = 8;
                case 8: throw e_3;
                case 9: return [3 /*break*/, 11];
                case 10:
                    e_4 = _g.sent();
                    throw e_4;
                case 11: return [2 /*return*/];
            }
        });
    });
};
export var putToServerAPIWithProvidedBearerToken = function (url, redirectBaseUrl, body, params, logoutUrl, isAdmin) {
    if (body === void 0) { body = {}; }
    if (params === void 0) { params = {}; }
    return __awaiter(void 0, void 0, Promise, function () {
        var b2cAccessToken, internalToken, bearerToken, response, e_5, response, response, e_6;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 10, , 11]);
                    b2cAccessToken = (_a = getB2CaccessToken()) !== null && _a !== void 0 ? _a : "";
                    internalToken = (_b = getInternalAccessToken()) !== null && _b !== void 0 ? _b : "";
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, , 9]);
                    bearerToken = "Bearer ".concat(b2cAccessToken);
                    return [4 /*yield*/, axios.put(url, body, {
                            headers: {
                                Authorization: bearerToken,
                                "Content-Type": "application/json; charset=utf-8",
                                InternalAuthorization: "Bearer ".concat(internalToken),
                            },
                            method: "PUT",
                            params: params,
                        })];
                case 2:
                    response = _g.sent();
                    if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        handleErrorsExceptRefresh(response, redirectBaseUrl);
                        throw new Error();
                    }
                    return [3 /*break*/, 9];
                case 3:
                    e_5 = _g.sent();
                    if (!(((_c = e_5 === null || e_5 === void 0 ? void 0 : e_5.response) === null || _c === void 0 ? void 0 : _c.status) === 401 &&
                        ((_d = e_5.response) === null || _d === void 0 ? void 0 : _d.data) &&
                        e_5.response.data.statusCode ===
                            StatusCode.B2C_ACCESS_TOKEN_EXPIRED)) return [3 /*break*/, 5];
                    return [4 /*yield*/, refreshB2CToken(url, redirectBaseUrl, internalToken, params, MethodTypes.POST, undefined, logoutUrl, isAdmin)];
                case 4:
                    response = _g.sent();
                    return [2 /*return*/, response];
                case 5:
                    if (!(((_e = e_5 === null || e_5 === void 0 ? void 0 : e_5.response) === null || _e === void 0 ? void 0 : _e.status) === 401 &&
                        ((_f = e_5.response) === null || _f === void 0 ? void 0 : _f.data) &&
                        e_5.response.data.statusCode ===
                            StatusCode.INTERNAL_ACCESS_TOKEN_EXPIRED)) return [3 /*break*/, 7];
                    return [4 /*yield*/, refreshInternalToken(url, redirectBaseUrl, b2cAccessToken, internalToken, params, MethodTypes.POST, undefined, logoutUrl, isAdmin)];
                case 6:
                    response = _g.sent();
                    return [2 /*return*/, response];
                case 7:
                    handleErrorsExceptRefresh(e_5.response, redirectBaseUrl);
                    _g.label = 8;
                case 8: throw e_5;
                case 9: return [3 /*break*/, 11];
                case 10:
                    e_6 = _g.sent();
                    throw e_6;
                case 11: return [2 /*return*/];
            }
        });
    });
};
export var postToServerAPIWithoutInternalToken = function (url, redirectBaseUrl, body, params, logoutUrl, isAdmin) {
    if (body === void 0) { body = {}; }
    if (params === void 0) { params = {}; }
    return __awaiter(void 0, void 0, Promise, function () {
        var b2cAccessToken, bearerToken, response, e_7, response, e_8;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 8, , 9]);
                    b2cAccessToken = (_a = getB2CaccessToken()) !== null && _a !== void 0 ? _a : "";
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 7]);
                    bearerToken = "Bearer ".concat(b2cAccessToken);
                    return [4 /*yield*/, axios.post(url, body, {
                            headers: {
                                Authorization: bearerToken,
                                "Content-Type": "application/json; charset=utf-8",
                                InternalAuthorization: "Bearer ".concat(null),
                            },
                            method: "POST",
                            params: params,
                        })];
                case 2:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        handleErrorsExceptRefresh(response, redirectBaseUrl);
                        throw new Error();
                    }
                    return [3 /*break*/, 7];
                case 3:
                    e_7 = _d.sent();
                    if (!(((_b = e_7 === null || e_7 === void 0 ? void 0 : e_7.response) === null || _b === void 0 ? void 0 : _b.status) === 401 &&
                        ((_c = e_7.response) === null || _c === void 0 ? void 0 : _c.data) &&
                        e_7.response.data.statusCode ===
                            StatusCode.B2C_ACCESS_TOKEN_EXPIRED)) return [3 /*break*/, 5];
                    return [4 /*yield*/, refreshB2CToken(url, redirectBaseUrl, "", params, MethodTypes.POST, undefined, logoutUrl, isAdmin)];
                case 4:
                    response = _d.sent();
                    return [2 /*return*/, response];
                case 5:
                    handleErrorsExceptRefresh(e_7.response, redirectBaseUrl);
                    _d.label = 6;
                case 6: throw e_7;
                case 7: return [3 /*break*/, 9];
                case 8:
                    e_8 = _d.sent();
                    throw e_8;
                case 9: return [2 /*return*/];
            }
        });
    });
};
export var getFromServerAPIWithoutInternalToken = function (url, redirectBaseUrl, params, logoutUrl, isAdmin) {
    if (params === void 0) { params = {}; }
    return __awaiter(void 0, void 0, Promise, function () {
        var b2cAccessToken, customConfig, bearerToken, response, e_9, customConfig, response, e_10;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 8, , 9]);
                    b2cAccessToken = (_a = getB2CaccessToken()) !== null && _a !== void 0 ? _a : "";
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 7]);
                    customConfig = {
                        params: {},
                        headers: {},
                    };
                    if (params != null)
                        customConfig.params = params;
                    bearerToken = "Bearer ".concat(b2cAccessToken);
                    return [4 /*yield*/, axios.get(url, {
                            headers: {
                                Authorization: bearerToken,
                                "Content-Type": "application/json; charset=utf-8",
                                InternalAuthorization: "Bearer ".concat(null),
                            },
                            method: "GET",
                            params: customConfig.params,
                        })];
                case 2:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        handleErrorsExceptRefresh(response, redirectBaseUrl);
                        throw new Error();
                    }
                    return [3 /*break*/, 7];
                case 3:
                    e_9 = _d.sent();
                    if (!(((_b = e_9 === null || e_9 === void 0 ? void 0 : e_9.response) === null || _b === void 0 ? void 0 : _b.status) === 401 &&
                        ((_c = e_9.response) === null || _c === void 0 ? void 0 : _c.data) &&
                        e_9.response.data.statusCode ===
                            StatusCode.B2C_ACCESS_TOKEN_EXPIRED)) return [3 /*break*/, 5];
                    customConfig = {
                        params: {},
                        headers: {},
                    };
                    if (params != null)
                        customConfig.params = params;
                    return [4 /*yield*/, refreshB2CToken(url, redirectBaseUrl, "", customConfig.params, MethodTypes.GET, undefined, logoutUrl, isAdmin)];
                case 4:
                    response = _d.sent();
                    return [2 /*return*/, response];
                case 5:
                    handleErrorsExceptRefresh(e_9.response, redirectBaseUrl);
                    _d.label = 6;
                case 6: throw e_9;
                case 7: return [3 /*break*/, 9];
                case 8:
                    e_10 = _d.sent();
                    throw e_10;
                case 9: return [2 /*return*/];
            }
        });
    });
};
export var postToServerAPIWithoutRedirections = function (url, body, params, logoutUrl, isAdmin) {
    if (body === void 0) { body = {}; }
    if (params === void 0) { params = {}; }
    return __awaiter(void 0, void 0, Promise, function () {
        var b2cAccessToken, internalToken, bearerToken, response, e_11, response, response, e_12;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    _j.trys.push([0, 9, , 10]);
                    b2cAccessToken = (_a = getB2CaccessToken()) !== null && _a !== void 0 ? _a : "";
                    internalToken = (_b = getInternalAccessToken()) !== null && _b !== void 0 ? _b : "";
                    _j.label = 1;
                case 1:
                    _j.trys.push([1, 3, , 8]);
                    bearerToken = "Bearer ".concat(b2cAccessToken);
                    return [4 /*yield*/, axios.post(url, body, {
                            headers: {
                                Authorization: bearerToken,
                                "Content-Type": "application/json; charset=utf-8",
                                InternalAuthorization: "Bearer ".concat(internalToken),
                            },
                            method: "POST",
                            params: params,
                        })];
                case 2:
                    response = _j.sent();
                    if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        throw new Error();
                    }
                    return [3 /*break*/, 8];
                case 3:
                    e_11 = _j.sent();
                    if (!(((_c = e_11 === null || e_11 === void 0 ? void 0 : e_11.response) === null || _c === void 0 ? void 0 : _c.status) === 401 &&
                        ((_d = e_11.response) === null || _d === void 0 ? void 0 : _d.data) &&
                        e_11.response.data.statusCode ===
                            StatusCode.B2C_ACCESS_TOKEN_EXPIRED)) return [3 /*break*/, 5];
                    return [4 /*yield*/, refreshB2CToken(url, (_e = process.env.REACT_APP_UMBRACO_PORTAL_URL) !== null && _e !== void 0 ? _e : "", internalToken, params, MethodTypes.POST, true, logoutUrl, isAdmin)];
                case 4:
                    response = _j.sent();
                    return [2 /*return*/, response];
                case 5:
                    if (!(((_f = e_11 === null || e_11 === void 0 ? void 0 : e_11.response) === null || _f === void 0 ? void 0 : _f.status) === 401 &&
                        ((_g = e_11.response) === null || _g === void 0 ? void 0 : _g.data) &&
                        e_11.response.data.statusCode ===
                            StatusCode.INTERNAL_ACCESS_TOKEN_EXPIRED)) return [3 /*break*/, 7];
                    return [4 /*yield*/, refreshInternalToken(url, (_h = process.env.REACT_APP_UMBRACO_PORTAL_URL) !== null && _h !== void 0 ? _h : "", b2cAccessToken, internalToken, params, MethodTypes.POST, true, logoutUrl, isAdmin)];
                case 6:
                    response = _j.sent();
                    return [2 /*return*/, response];
                case 7: throw e_11;
                case 8: return [3 /*break*/, 10];
                case 9:
                    e_12 = _j.sent();
                    throw e_12;
                case 10: return [2 /*return*/];
            }
        });
    });
};
export var getFromServerAPIWithoutRedirections = function (url, params, logoutUrl, isAdmin) {
    if (params === void 0) { params = {}; }
    return __awaiter(void 0, void 0, Promise, function () {
        var b2cAccessToken, internalToken, customConfig, bearerToken, response, e_13, customConfig, response, customConfig, response, e_14;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    _j.trys.push([0, 9, , 10]);
                    b2cAccessToken = (_a = getB2CaccessToken()) !== null && _a !== void 0 ? _a : "";
                    internalToken = (_b = getInternalAccessToken()) !== null && _b !== void 0 ? _b : "";
                    _j.label = 1;
                case 1:
                    _j.trys.push([1, 3, , 8]);
                    customConfig = {
                        params: {},
                        headers: {},
                    };
                    if (params != null)
                        customConfig.params = params;
                    bearerToken = "Bearer ".concat(b2cAccessToken);
                    return [4 /*yield*/, axios.get(url, {
                            headers: {
                                Authorization: bearerToken,
                                "Content-Type": "application/json; charset=utf-8",
                                InternalAuthorization: "Bearer ".concat(internalToken),
                            },
                            method: "GET",
                            params: customConfig.params,
                        })];
                case 2:
                    response = _j.sent();
                    if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        throw new Error();
                    }
                    return [3 /*break*/, 8];
                case 3:
                    e_13 = _j.sent();
                    if (!(((_c = e_13 === null || e_13 === void 0 ? void 0 : e_13.response) === null || _c === void 0 ? void 0 : _c.status) === 401 &&
                        ((_d = e_13.response) === null || _d === void 0 ? void 0 : _d.data) &&
                        e_13.response.data.statusCode ===
                            StatusCode.B2C_ACCESS_TOKEN_EXPIRED)) return [3 /*break*/, 5];
                    customConfig = {
                        params: {},
                        headers: {},
                    };
                    if (params != null)
                        customConfig.params = params;
                    return [4 /*yield*/, refreshB2CToken(url, (_e = process.env.REACT_APP_UMBRACO_PORTAL_URL) !== null && _e !== void 0 ? _e : "", internalToken, customConfig.params, MethodTypes.GET, true, logoutUrl, isAdmin)];
                case 4:
                    response = _j.sent();
                    return [2 /*return*/, response];
                case 5:
                    if (!(((_f = e_13 === null || e_13 === void 0 ? void 0 : e_13.response) === null || _f === void 0 ? void 0 : _f.status) === 401 &&
                        ((_g = e_13.response) === null || _g === void 0 ? void 0 : _g.data) &&
                        e_13.response.data.statusCode ===
                            StatusCode.INTERNAL_ACCESS_TOKEN_EXPIRED)) return [3 /*break*/, 7];
                    customConfig = {
                        params: {},
                        headers: {},
                    };
                    if (params != null)
                        customConfig.params = params;
                    return [4 /*yield*/, refreshInternalToken(url, (_h = process.env.REACT_APP_UMBRACO_PORTAL_URL) !== null && _h !== void 0 ? _h : "", b2cAccessToken, internalToken, params, MethodTypes.GET, true, logoutUrl, isAdmin)];
                case 6:
                    response = _j.sent();
                    return [2 /*return*/, response];
                case 7: throw e_13;
                case 8: return [3 /*break*/, 10];
                case 9:
                    e_14 = _j.sent();
                    throw e_14;
                case 10: return [2 /*return*/];
            }
        });
    });
};
var refreshB2CToken = function (url, redirectBaseUrl, internalToken, params, methodType, withoutRedirection, logoutUrl, isAdmin) {
    if (params === void 0) { params = {}; }
    if (withoutRedirection === void 0) { withoutRedirection = false; }
    return __awaiter(void 0, void 0, Promise, function () {
        var b2cRefreshToken, response, newToken, responseNew, responseNew, e_15, responseRefreshed, e_16;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 15, , 17]);
                    b2cRefreshToken = (_a = getB2CrefreshToken()) !== null && _a !== void 0 ? _a : "";
                    return [4 /*yield*/, axios.post(API_REFRESH_B2C_TOKEN_URL, {
                            refreshToken: b2cRefreshToken,
                        })];
                case 1:
                    response = _d.sent();
                    if (!(response && response.data)) return [3 /*break*/, 12];
                    newToken = response.data.b2cAccessToken;
                    setB2CaccessToken(newToken);
                    _d.label = 2;
                case 2:
                    _d.trys.push([2, 7, , 11]);
                    if (!(methodType === MethodTypes.GET)) return [3 /*break*/, 4];
                    return [4 /*yield*/, axios.get(url, {
                            headers: {
                                Authorization: "Bearer ".concat(newToken),
                                "Content-Type": "application/json; charset=utf-8",
                                InternalAuthorization: "Bearer ".concat(internalToken),
                            },
                            method: "GET",
                            params: params,
                        })];
                case 3:
                    responseNew = _d.sent();
                    if (responseNew && responseNew.data) {
                        return [2 /*return*/, responseNew.data];
                    }
                    return [3 /*break*/, 6];
                case 4:
                    if (!(methodType === MethodTypes.POST)) return [3 /*break*/, 6];
                    return [4 /*yield*/, axios.post(url, params, {
                            headers: {
                                Authorization: "Bearer ".concat(newToken),
                                "Content-Type": "application/json; charset=utf-8",
                                InternalAuthorization: "Bearer ".concat(internalToken),
                            },
                            method: "POST",
                        })];
                case 5:
                    responseNew = _d.sent();
                    if (responseNew && responseNew.data) {
                        return [2 /*return*/, responseNew.data];
                    }
                    _d.label = 6;
                case 6: return [3 /*break*/, 11];
                case 7:
                    e_15 = _d.sent();
                    if (!(((_b = e_15 === null || e_15 === void 0 ? void 0 : e_15.response) === null || _b === void 0 ? void 0 : _b.status) === 401 &&
                        ((_c = e_15.response) === null || _c === void 0 ? void 0 : _c.data) &&
                        e_15.response.data.statusCode ===
                            StatusCode.INTERNAL_ACCESS_TOKEN_EXPIRED)) return [3 /*break*/, 9];
                    return [4 /*yield*/, refreshInternalToken(url, redirectBaseUrl, newToken, internalToken, params, methodType, withoutRedirection, logoutUrl, isAdmin)];
                case 8:
                    responseRefreshed = _d.sent();
                    return [2 /*return*/, responseRefreshed];
                case 9:
                    if (withoutRedirection) {
                        throw e_15;
                    }
                    else {
                        if (withoutRedirection) {
                            throw e_15;
                        }
                        else {
                            handleErrorsExceptRefresh(e_15.response, redirectBaseUrl);
                        }
                    }
                    _d.label = 10;
                case 10: return [3 /*break*/, 11];
                case 11: return [3 /*break*/, 14];
                case 12: return [4 /*yield*/, handleIncorrectB2CRefreshTokenError(logoutUrl, isAdmin)];
                case 13:
                    _d.sent();
                    _d.label = 14;
                case 14: return [3 /*break*/, 17];
                case 15:
                    e_16 = _d.sent();
                    return [4 /*yield*/, handleIncorrectB2CRefreshTokenError(logoutUrl, isAdmin)];
                case 16:
                    _d.sent();
                    return [3 /*break*/, 17];
                case 17: return [2 /*return*/];
            }
        });
    });
};
var refreshInternalToken = function (url, redirectBaseUrl, b2cAccessToken, internalToken, params, methodType, withoutRedirection, logoutUrl, isAdmin) {
    if (params === void 0) { params = {}; }
    if (withoutRedirection === void 0) { withoutRedirection = false; }
    return __awaiter(void 0, void 0, Promise, function () {
        var internalRefreshToken, bearerToken, response, newAccessToken, newRefreshToken, responseNew, responseNew, e_17, responseRefreshed, e_18;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 15, , 17]);
                    internalRefreshToken = (_a = getInternalRefreshToken()) !== null && _a !== void 0 ? _a : "";
                    bearerToken = "Bearer ".concat(b2cAccessToken);
                    return [4 /*yield*/, axios.post(API_REFRESH_INTERNAL_TOKEN_URL, {
                            refreshToken: internalRefreshToken,
                            accessToken: internalToken,
                        }, {
                            headers: {
                                Authorization: bearerToken,
                                "Content-Type": "application/json; charset=utf-8",
                                InternalAuthorization: "Bearer ".concat(internalToken),
                            },
                            method: "POST",
                        })];
                case 1:
                    response = _d.sent();
                    if (!(response && response.data)) return [3 /*break*/, 12];
                    newAccessToken = response.data.data.accessToken.token;
                    setInternalAccessToken(newAccessToken);
                    newRefreshToken = response.data.data.refreshToken.token;
                    setInternalRefreshToken(newRefreshToken);
                    _d.label = 2;
                case 2:
                    _d.trys.push([2, 7, , 11]);
                    if (!(methodType === MethodTypes.GET)) return [3 /*break*/, 4];
                    return [4 /*yield*/, axios.get(url, {
                            headers: {
                                Authorization: "Bearer ".concat(b2cAccessToken),
                                "Content-Type": "application/json; charset=utf-8",
                                InternalAuthorization: "Bearer ".concat(newAccessToken),
                            },
                            method: "GET",
                            params: params,
                        })];
                case 3:
                    responseNew = _d.sent();
                    if (responseNew && responseNew.data) {
                        return [2 /*return*/, responseNew.data];
                    }
                    return [3 /*break*/, 6];
                case 4:
                    if (!(methodType === MethodTypes.POST)) return [3 /*break*/, 6];
                    return [4 /*yield*/, axios.post(url, params, {
                            headers: {
                                Authorization: "Bearer ".concat(b2cAccessToken),
                                "Content-Type": "application/json; charset=utf-8",
                                InternalAuthorization: "Bearer ".concat(newAccessToken),
                            },
                            method: "POST",
                            params: params,
                        })];
                case 5:
                    responseNew = _d.sent();
                    if (responseNew && responseNew.data) {
                        return [2 /*return*/, responseNew.data];
                    }
                    _d.label = 6;
                case 6: return [3 /*break*/, 11];
                case 7:
                    e_17 = _d.sent();
                    if (!(((_b = e_17 === null || e_17 === void 0 ? void 0 : e_17.response) === null || _b === void 0 ? void 0 : _b.status) === 401 &&
                        ((_c = e_17.response) === null || _c === void 0 ? void 0 : _c.data) &&
                        e_17.response.data.statusCode ===
                            StatusCode.B2C_ACCESS_TOKEN_EXPIRED)) return [3 /*break*/, 9];
                    return [4 /*yield*/, refreshB2CToken(url, redirectBaseUrl, newAccessToken, params, methodType, withoutRedirection, logoutUrl, isAdmin)];
                case 8:
                    responseRefreshed = _d.sent();
                    return [2 /*return*/, responseRefreshed];
                case 9:
                    if (withoutRedirection) {
                        throw e_17;
                    }
                    else {
                        handleErrorsExceptRefresh(e_17.response, redirectBaseUrl);
                    }
                    _d.label = 10;
                case 10: return [3 /*break*/, 11];
                case 11: return [3 /*break*/, 14];
                case 12: return [4 /*yield*/, handleIncorrectInternalRefreshTokenError(logoutUrl, isAdmin)];
                case 13:
                    _d.sent();
                    _d.label = 14;
                case 14: return [3 /*break*/, 17];
                case 15:
                    e_18 = _d.sent();
                    return [4 /*yield*/, handleIncorrectInternalRefreshTokenError(logoutUrl, isAdmin)];
                case 16:
                    _d.sent();
                    return [3 /*break*/, 17];
                case 17: return [2 /*return*/];
            }
        });
    });
};
var handleErrorsExceptRefresh = function (response, redirectBaseUrl) {
    if ((response === null || response === void 0 ? void 0 : response.status) === 500) {
        window.location.href = redirectBaseUrl + "/error/error500";
    }
    else if ((response === null || response === void 0 ? void 0 : response.status) === 400) {
        window.location.href = redirectBaseUrl + "/error/error400";
    }
    else if ((response === null || response === void 0 ? void 0 : response.status) === 401) {
        window.location.href = redirectBaseUrl + "/error/error401";
    }
    else if ((response === null || response === void 0 ? void 0 : response.status) === 403) {
        window.location.href = redirectBaseUrl + "/error/error403";
    }
    else if ((response === null || response === void 0 ? void 0 : response.status) === 404) {
        window.location.href = redirectBaseUrl + "/error/error404";
    }
    else {
        window.location.href = redirectBaseUrl + "/error/error500";
    }
};
var handleIncorrectB2CRefreshTokenError = function (logoutUrl, isAdmin) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        clearAllValuesFromStorages();
        if (logoutUrl) {
            window.location.href = logoutUrl;
        }
        else if (isAdmin === true) {
            window.location.href = LOGOUT_ADMIN_REDIRECT_URL;
            return [2 /*return*/];
        }
        else {
            window.location.href = LEGACY_LOGOUT_REDIRECT_URL;
        }
        return [2 /*return*/];
    });
}); };
var handleIncorrectInternalRefreshTokenError = function (logoutUrl, isAdmin) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        clearAllValuesFromStorages();
        if (logoutUrl) {
            window.location.href = logoutUrl;
        }
        else if (isAdmin === true) {
            window.location.href = LOGOUT_ADMIN_REDIRECT_URL;
        }
        else {
            window.location.href = LEGACY_LOGOUT_REDIRECT_URL;
        }
        return [2 /*return*/];
    });
}); };
